export const cleanObject = (obj) => {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => 
      value !== "" && value !== null && value !== undefined  && !(typeof value === "number" && isNaN(value))
    )
  );
};
